import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Icon,
    IconButton,
    InputAdornment,
    TextField,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    ButtonGroup,
    InputLabel,
    Select,
    Tabs,
    Tab,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AptaTable from "examples/AptaTable";
import MDBox from "components/MDBox";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Search, Delete, FileDownload } from "@mui/icons-material";
import { SERVER_URL } from "constants/constant";
import * as XLSX from 'xlsx';


export const Author = ({ name, email, idx }) => (
    <MDBox lineHeight={1} style={{ display: "flex" }}>
        {/* <Icon color="inherit" fontSize="large">account_circle</Icon> */}
        <MDBox ml={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">{name}</MDTypography>
            <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
    </MDBox>
);

const options = [
    { value: "Vegetarian", label: "Vegetarian" },
    { value: "Non-Vegetarian", label: "Non-Vegetarian" },
    { value: "Jain_food", label: "Jain Food" }
]

function Users() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [indianDelegates, setIndianDelegates] = useState([]);
    const [foreignDelegates, setForeignDelegates] = useState([])
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false)
    const [selectedTab, setSelectedTab] = useState(1)
    const handleEditOpen = (user) => {
        setSelectedUser(user);
        setEditDialogOpen(true);
    };

    const handleEditClose = () => {
        setEditDialogOpen(false);
        setSelectedUser(null);
    };

    const handleEditSubmit = async () => {
        try {
            await axios.put(`${SERVER_URL}/user/edit/${selectedUser._id}`, selectedUser);
            Swal.fire("Success!", "User details updated successfully!", "success");
            fetchUsers();
            handleEditClose();
        } catch (error) {
            Swal.fire("Error!", "Failed to update user details.", "error");
        }
    };



    useEffect(() => {
        fetchUsers();
    }, []);

    async function fetchUsers() {
        try {
            const response = await axios.get(`${SERVER_URL}/get-all-additional-people`);
            if (response.status === 200) {
                const allUsers = response?.data?.data?.reverse()
                setUsers(allUsers);
                const indian = allUsers?.filter(user => user?.registrationCategory?.regiCategoryType !== "Foreign_Delegate");
                const foreign = allUsers?.filter(user => user?.registrationCategory?.regiCategoryType === "Foreign_Delegate");
                // setIndianDelegates(indian);
                setIndianDelegates(indian?.filter(i => i?.mainPersonRegistrationCategory !== "TRADE"))

                setForeignDelegates(foreign);
            } else {
                console.error("Unexpected response code:", response.status);
            }
        } catch (error) {
            console.error("Error fetching users:", error.response?.data || error.message);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    }
    useEffect(() => {
        if (searchQuery === "") {
            const indian = users?.filter(user => user?.registrationCategory?.regiCategoryType !== "Foreign_Delegate");
            const foreign = users?.filter(user => user?.registrationCategory?.regiCategoryType === "Foreign_Delegate");
            if (selectedTab === 0) {
                setIndianDelegates(indian?.filter(i => i?.mainPersonRegistrationCategory === "TRADE"));
                setForeignDelegates(foreign);
            } else {
                setIndianDelegates(indian?.filter(i => i?.mainPersonRegistrationCategory !== "TRADE"));
                setForeignDelegates(foreign);
            }

        } else {
            const filteredUsers1 = users?.filter(user => user?.registrationCategory?.regiCategoryType !== "Foreign_Delegate")?.filter((user) =>
                user?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) || user?.mainPersonName?.toLowerCase()?.includes(searchQuery?.toLowerCase())

            );
            const filteredUsers2 = users?.filter(user => user?.registrationCategory?.regiCategoryType)?.filter((user) =>
                user?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) || user?.mainPersonName?.toLowerCase()?.includes(searchQuery?.toLowerCase())

            );
            if (selectedTab === 0) {
                // Change
                setIndianDelegates(filteredUsers1?.filter(i => i?.registrationCategory?.regiCategoryName === "TRADE"))
            } else {
                setIndianDelegates(filteredUsers1?.filter(i => i?.registrationCategory?.regiCategoryName !== "TRADE"))
                setForeignDelegates(filteredUsers2)
            }

        }
    }, [searchQuery])

    useEffect(() => {
        if (selectedTab === 0) {
            // change
            setIndianDelegates(users?.filter(i => i?.mainPersonRegistrationCategory === "TRADE"))
        } else {
            // change
            setIndianDelegates(users?.filter(i => i?.mainPersonRegistrationCategory !== "TRADE"))
        }
    }, [selectedTab])


    const exportToExcel = (users, fileName) => {
        const filteredUsersForExcel = users?.map(({
            name,
            gender,
            foodCategory,
            paymentStatus,
            userId,
            registrationCategory,
            mainPersonPhoneNumber,
            mainPersonName,
            createdAt
        }) => ({
            'Delegate': mainPersonName || '',
            'Delegate Number': mainPersonPhoneNumber || '',
            'Registration Date': createdAt?.slice(0, 10),
            "Name": name || '',
            "Gender": gender || '',
            "Food Category": foodCategory || '',
            "User Id": userId || '',
            'Status': paymentStatus || '',
            'Price': registrationCategory?.price || ''
        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredUsersForExcel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const handleTabChange = (_, newValue) => {
        console.log(newValue);

        setSelectedTab(newValue);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SearchInput searchQuery={searchQuery} handleSearchChange={handleSearchChange} />
            <Box mb={3}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    centered>
                    <Tab label="Trade (Indian Only)" />
                    <Tab label="Non-Trade" />
                </Tabs>
            </Box>
            <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button style={{ color: 'white', backgroundColor: '#2ecc71' }}
                    onClick={() => exportToExcel(indianDelegates, "Indian_Delegates")}
                    variant='contained' >Download Indian Excel</Button>
                {selectedTab === 1 && <Button style={{ color: 'white', backgroundColor: '#3498db', marginLeft: 10 }}
                    onClick={() => exportToExcel(foreignDelegates, "Foreign_Delegates")}
                    variant='contained' >Download Foreign Excel</Button>}
            </Box>
            <AptaTable
                title={"Indian Accompanying Persons"}

                columns={['Delegate', 'Delegate Number', 'Registration Date', 'Name', 'Gender', 'Food Preference', 'User ID', 'Price', 'Status',]}
                rows={indianDelegates?.map((person) => ({
                    'Delegate': person?.mainPersonName,
                    "Delegate Number": person?.mainPersonPhoneNumber,
                    'Registration Date': person?.createdAt?.slice(0, 10) || '--',
                    "Name": person.name,
                    "Gender": person.gender,
                    "Food Preference": person.foodCategory,
                    "User ID": person.userId,
                    "Price": person?.registrationCategory?.price,
                    "Status":
                        <MDTypography variant="caption" fontWeight="bold" color={person.paymentStatus === "paid" ? "success" : "error"}>
                            {person.paymentStatus}
                        </MDTypography>,

                }))}

            />
            {selectedTab === 1 && <AptaTable
                title={"Foreign Delegates"}
                columns={['Delegate', 'Delegate Number', 'Registration Date', 'Name', 'Gender', 'Food Preference', 'User ID', 'Price', 'Status',]}
                rows={foreignDelegates?.map((person) => ({
                    'Delegate': person?.mainPersonName,
                    "Delegate Number": person?.mainPersonPhoneNumber,
                    'Registration Date': person?.createdAt?.slice(0, 10) || '--',
                    "Name": person.name,
                    "Gender": person.gender,
                    "Food Preference": person.foodCategory,
                    "User ID": person.userId,
                    "Price": person?.registrationCategory?.price,
                    "Status":
                        <MDTypography variant="caption" fontWeight="bold" color={person.paymentStatus === "paid" ? "success" : "error"}>
                            {person.paymentStatus}
                        </MDTypography>,

                }))}

            />}
            {
                selectedUser && (
                    <Dialog open={editDialogOpen} onClose={handleEditClose}>
                        <DialogTitle>Edit User</DialogTitle>
                        <DialogContent>
                            <TextField label="Email" fullWidth margin="dense" value={selectedUser.email} onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })} />
                            <TextField label="Phone" fullWidth margin="dense" value={selectedUser.phoneNumber} onChange={(e) => setSelectedUser({ ...selectedUser, phoneNumber: e.target.value })} />
                            <TextField label="Institute" fullWidth margin="dense" value={selectedUser.institute} onChange={(e) => setSelectedUser({ ...selectedUser, institute: e.target.value })} />


                            <TextField label="Address" fullWidth margin="dense" value={selectedUser.address} onChange={(e) => setSelectedUser({ ...selectedUser, address: e.target.value })} />
                            <TextField label="City" fullWidth margin="dense" value={selectedUser.city} onChange={(e) => setSelectedUser({ ...selectedUser, city: e.target.value })} />
                            <TextField label="State" fullWidth margin="dense" value={selectedUser.state} onChange={(e) => setSelectedUser({ ...selectedUser, state: e.target.value })} />
                            <TextField label="Pincode" fullWidth margin="dense" value={selectedUser.pincode} onChange={(e) => setSelectedUser({ ...selectedUser, pincode: e.target.value })} />
                            <Box>
                                <InputLabel sx={{ paddingBottom: 1, marginTop: 2 }}>Food Preference</InputLabel>
                                <Select
                                    value={selectedUser.foodCategory} name="parentCategory"
                                    onChange={(e) => setSelectedUser({ ...selectedUser, foodCategory: e.target.value })} placeholder="Select a category"
                                    fullWidth
                                    style={{ height: 40 }}
                                >
                                    <MenuItem value="Select Food Preference" disabled >
                                        Select Food Preference
                                    </MenuItem>
                                    {options.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </DialogContent>
                        <DialogActions>

                            <Button onClick={handleEditClose}>Cancel</Button>
                            <Button onClick={handleEditSubmit} color="primary">Save</Button>
                        </DialogActions>
                    </Dialog>
                )
            }
        </DashboardLayout>
    );
}



export default Users;

// SearchInput Component
export const SearchInput = ({ searchQuery, handleSearchChange }) => (
    <Box display="flex" justifyContent="center" mb={3} width="100%">
        <TextField
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by name, phone, email..."
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton>
                            <Search />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    </Box>
);


